import {Api, HTTPMethod, buildExport} from "@next/apiconfig"
import {addTestingVariant} from "../../../utils/testingVariant"
import env from "../../env"

const {REACT_APP_MEGANAV_API_BASEURL, ASSETS_PATH, REACT_APP_SERVE_PATH_PREFIX} = env

export const routeDefinitions = {
    getPrimaryNavData: `${REACT_APP_SERVE_PATH_PREFIX}/primary-nav`,
    getSecondaryNavData: `${REACT_APP_SERVE_PATH_PREFIX}/secondary-items/:page/:department`,
    getSeoData: `${ASSETS_PATH}/seo-content/:page/:department*?`,
    getSeoDataOnClient: `${ASSETS_PATH}/seo-content`,
}

const endpoints = {
    getPrimaryNavData: {
        routeDefinition: routeDefinitions.getPrimaryNavData,
        getLocalURL: () => `${REACT_APP_SERVE_PATH_PREFIX}/primary-nav`,
        getRemoteURL: () => `/primary-items/Home`,
        method: HTTPMethod.get,
    },
    getSecondaryNavData: {
        routeDefinition: routeDefinitions.getSecondaryNavData,
        getLocalURL: (page: string, department: string, testingVariant?: string) =>
            addTestingVariant(`${REACT_APP_SERVE_PATH_PREFIX}/secondary-items/${page}/${department}`, testingVariant),
        getRemoteURL: (page: string, department: string, testingVariant?: string) =>
            addTestingVariant(`/primary-items/${page}/secondary-items/${department}`, testingVariant),
        method: HTTPMethod.get,
    },
    getSeoData: {
        routeDefinition: routeDefinitions.getSeoData,
        getLocalURL: () => "",
        getRemoteURL: (page: string, department: string) => `/seo-content/${page}/${department}`,
        method: HTTPMethod.get,
    },
    getSeoDataOnClient: {
        routeDefinition: routeDefinitions.getSeoDataOnClient,
        getLocalURL: () => `${ASSETS_PATH}/seo-content`,
        getRemoteURL: () => `/seo-content/home?excludeLimit=true`,
        method: HTTPMethod.get,
    },
}

export default (endpoint: keyof typeof endpoints, versionId?: string) => {
    class MegaNavApi implements Api {
        baseURL = `${REACT_APP_MEGANAV_API_BASEURL}`
        version = versionId || "v1"
        endpoints = endpoints
    }
    const meganavApi = new MegaNavApi()

    return buildExport(meganavApi, endpoint)
}
